import { render, staticRenderFns } from "./VideoRecorder.vue?vue&type=template&id=0447384e&scoped=true"
import script from "./VideoRecorder.vue?vue&type=script&lang=js"
export * from "./VideoRecorder.vue?vue&type=script&lang=js"
import style0 from "./VideoRecorder.vue?vue&type=style&index=0&id=0447384e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0447384e",
  null
  
)

export default component.exports